<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">
  <form class="popup-container service-setup-popup form-container" #f="ngForm" (ngSubmit)="onSubmit(f)" style=" width: 100%; max-width: 600px; min-width: 100%;">
    <!--popup content - container for popup content (do not change styling )-->
    <div class="popup-content" style=" width: 100%; max-width: 700px;">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>

      <!-- popup body -->
      <div class="popup-body">
        <!-- popup body - setup form -->
        <div class="popup-setup-form" *ngIf="popup?.PopupAction == 'New' || popup?.PopupAction == 'Edit'">
          <div class="form-group row justify-space-between align-center">
            <label>Service Section:</label>
            <app-custom-dropdown [options]="SP_Types"
                                 [placeholder]="'Select an option'"
                                 [(ngModel)]="service.SPTypeGuid"
                                 [optionsText]="'SPType'"
                                 [ngModelOptions]="{standalone: true}"
                                 [optionsValue]="'Guid'">
            </app-custom-dropdown>
          </div>
          <div class="form-group row justify-space-between align-center" >
            <span *ngIf="Name.invalid && submitted" class="invalid-text">*</span>
            <label>Service Title:</label>
            <input type="text" class="input-control" placeholder="Enter Service Name" [(ngModel)]="service.Name" id="Name" name="Name" #Name="ngModel" style="width: 75%;" [ngClass]="{'invalid-border': Name.invalid && submitted}" required/>
          </div>

          <div class="form-group row justify-space-between align-center">
            <label>Service Duration:</label>
            <app-custom-dropdown [options]="durations"
                                 [placeholder]="'Select time'"
                                 [(ngModel)]="service.Duration"
                                 [optionsText]="'Description'"
                                 [optionsValue]="'Description'"
                                 [ngModelOptions]="{standalone: true}"
                                 textSuffix="min">
            </app-custom-dropdown>
          </div>
          <div class="form-group column">
            <label>Service Description:</label>
            <textarea class="form-control" [(ngModel)]="service.Description" style="height: 70px; padding: 10px; " [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div class="form-group column">
            <label>Service Notes:</label>
            <textarea class="form-control" [(ngModel)]="service.Notes" style="height: 150px; padding: 10px; " [ngModelOptions]="{standalone: true}"></textarea>
          </div>
        </div>

        <!-- popup body - content view -->
        <div class="popup-setup-view" *ngIf="popup?.PopupAction == 'View'" style=" max-width: 800px;">
          <div class="content-group">
            <p>Service Section</p>
            <p style="text-transform: uppercase;"><span>{{serviceSection}}</span></p>
          </div>
          <div class="content-group">
            <p>Service Title:</p>
            <p><span>{{service.Name}}</span></p>
          </div>
          <div class="content-group">
            <p>Service Description:</p>
            <p>{{service.Description}}</p>
          </div>
          <div class="content-group">
            <p>Service Duration:</p>
            <p><span>{{service.Duration}}min</span></p>
          </div>
          <div class="content-group">
            <p>Service Notes:</p>
            <p>{{service.Notes}}</p>
          </div>
        </div>
        <div class="popup-buttons">
          <button type="submit" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">
            {{ popup?.AltButton?.ButtonText }}
          </button>
        </div>
      </div>

      <!--popup content view-->
      <!-- popup footer - popup buttons-->
      
    </div>
  </form>
</div>
